import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';
import '../../../styles/time-picker.css';
import 'react-clock/dist/Clock.css';
import Modal from 'react-modal';
import Select from 'react-select';
import DSelect from 'react-dropdown-select';

import { PieChart } from 'react-minimal-pie-chart';






const ShiftNew = () => {
    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [addShiftDetailModalOpen, setAddShiftDetailModalOpen] = useState(false);
    const [addShift, setAddShift] = useState(null);

    const [shift, setShift] = useState(null);
    const [shiftStart, setShiftStart] = useState(false);
    const [shiftEnd, setShiftEnd] = useState(false);



    const [totalEarning, setTotalEarning] = useState(0);
    const [todayEarning, setTodayEarning] = useState(0);

    const [dailyEarning, setDailyEarning] = useState(0);

    const [weeklyEarning, setWeeklyEarning] = useState(0);
    const [completedEarning, setCompletedEarning] = useState(0);
    const [thisWeekEarning, setThisWeekEarning] = useState(0);

const [addOTModalOpen, setAddOTModalOpen] = useState(false);
const [otHours, setOtHours] = useState("");


    const [errors, setErrors] = useState(null);
    const options_weeks = [...new Array(99)].map((each, index) => ({ label: index + 1 + " weeks", value: index + 1 }));
    const options_hours = Array.from({ length: 12 }, (_, i) => ({ label: (i + 1).toString().padStart(2, '0'), value: (i + 1).toString().padStart(2, '0') }));
    const options_minutes = Array.from({ length: 60 }, (_, i) => ({ label: i.toString().padStart(2, '0'), value: i.toString().padStart(2, '0') }));
    const options_meridiems = [{ label: "AM", value: "AM" }, { label: "PM", value: "PM" }];
    const [editShiftModalOpen, setEditShiftModalOpen] = useState(false);
    const [editShift, setEditShift] = useState(null);


    useEffect(() => {
        getShift();


    }, []);

    useEffect(() => {

        if (shift && shift?.user_id > 0) {

            const interval = setInterval(() => {
                //  getShiftEveryMinute();
                getShift();
            }, 6000); // 60,000 ms = 1 minute

            return () => clearInterval(interval);
        }
    }, [shift]);

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

 



    const getShift = async () => {
        axios.get(process.env.REACT_APP_API_URL + "/get-shift", {
            params: {
                user_date: formatDate(new Date()), 
                user_time: getLocalTimeHHMM(),
            },
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                setShift(null);
                if (response?.data?.status && response?.data?.shift && response?.data?.shift.hourly_rate > 0) {

                    let shift_tmp = response?.data?.shift;


                    setThisWeekEarning(response?.data?.this_week_earning);
                    setDailyEarning(response?.data?.today_earning);
                    //                    const t1 = getEarningsTillNow(shift_tmp.hourly_rate, shift_tmp.daily_hours,  start_time, end_time)
                    //alert(t1);
                    setTodayEarning(response?.data?.today_earning);

                    setWeeklyEarning(response?.data?.weekly_earning);
                    setTotalEarning(response?.data?.total_earning);
                    setCompletedEarning(response?.data?.completed_earning);
                    setShift(shift_tmp)

                }
                setIsBtn(false)

            })
            .catch(function (error) {
                setIsBtn(false)
                if (error.status == 403) navigate("/login")
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });
    }




    const AddShiftDetails = async (e) => {
        setAddShift(null);
        setAddShiftDetailModalOpen(true);
    }


    const onChangeStartTimeHours = async (e) => {

        console.log(addShift);

        if (e[0] && addShift?.start_time_minutes?.length > 0 && addShift?.start_time_meridiems?.length > 0) {

            setAddShift({ ...addShift, start_time_hours: e[0].value, start_time: (e[0].value + ":" + addShift?.start_time_minutes + " " + addShift?.start_time_meridiems) })


        }
        else {
            setAddShift({ ...addShift, start_time_hours: e[0]?.value, start_time: "" })

        }
        // setAddShift({ ...addShift, start_time: e })

    }
    const onChangeStartTimeMinutes = async (e) => {

        console.log(e);

        if (e[0] && addShift?.start_time_hours?.length > 0 && addShift?.start_time_meridiems?.length > 0) {

            setAddShift({ ...addShift, start_time_minutes: e[0].value, start_time: (addShift?.start_time_hours + ":" + e[0].value + " " + addShift?.start_time_meridiems) })


        }
        else {
            setAddShift({ ...addShift, start_time_minutes: e[0]?.value, start_time: "" })

        }

    }

    const onChangeStartTimeMeridiems = async (e) => {

        console.log(e);
        if (e[0] && addShift?.start_time_hours?.length > 0 && addShift?.start_time_minutes?.length > 0) {

            setAddShift({ ...addShift, start_time_meridiems: e[0].value, start_time: (addShift?.start_time_hours + ":" + addShift?.start_time_minutes + " " + e[0].value) })


        }
        else {
            setAddShift({ ...addShift, start_time_meridiems: e[0]?.value, start_time: "" })

        }

    }


    const onChangeEndTimeHours = async (e) => {

        console.log(addShift);

        if (e[0] && addShift?.end_time_minutes?.length > 0 && addShift?.end_time_meridiems?.length > 0) {

            setAddShift({ ...addShift, end_time_hours: e[0].value, end_time: (e[0].value + ":" + addShift?.end_time_minutes + " " + addShift?.end_time_meridiems) })


        }
        else {
            setAddShift({ ...addShift, end_time_hours: e[0]?.value, end_time: "" })

        }
        // setAddShift({ ...addShift, end_time: e })

    }
    const onChangeEndTimeMinutes = async (e) => {

        console.log(e);

        if (e[0] && addShift?.end_time_hours?.length > 0 && addShift?.end_time_meridiems?.length > 0) {

            setAddShift({ ...addShift, end_time_minutes: e[0].value, end_time: (addShift?.end_time_hours + ":" + e[0].value + " " + addShift?.end_time_meridiems) })


        }
        else {
            setAddShift({ ...addShift, end_time_minutes: e[0]?.value, end_time: "" })

        }

    }

    const onChangeEndTimeMeridiems = async (e) => {


        if (e[0] && addShift?.end_time_hours?.length > 0 && addShift?.end_time_minutes?.length > 0) {

            setAddShift({ ...addShift, end_time_meridiems: e[0].value, end_time: (addShift?.end_time_hours + ":" + addShift?.end_time_minutes + " " + e[0].value) })

        }
        else {

            setAddShift({ ...addShift, end_time_meridiems: e[0]?.value, end_time: "" })

        }

    }



    const onChangeEditStartTimeHours = (e) => {
        if (e[0] && editShift?.start_time_minutes?.length > 0 && editShift?.start_time_meridiems?.length > 0) {
            setEditShift({
                ...editShift,
                start_time_hours: e[0].value,
                start_time: `${e[0].value}:${editShift.start_time_minutes} ${editShift.start_time_meridiems}`
            });
        } else {
            setEditShift({
                ...editShift,
                start_time_hours: e[0]?.value,
                start_time: ""
            });
        }
    };

    const onChangeEditStartTimeMinutes = (e) => {
        if (e[0] && editShift?.start_time_hours?.length > 0 && editShift?.start_time_meridiems?.length > 0) {
            setEditShift({
                ...editShift,
                start_time_minutes: e[0].value,
                start_time: `${editShift.start_time_hours}:${e[0].value} ${editShift.start_time_meridiems}`
            });
        } else {
            setEditShift({
                ...editShift,
                start_time_minutes: e[0]?.value,
                start_time: ""
            });
        }
    };

    const onChangeEditStartTimeMeridiems = (e) => {
        if (e[0] && editShift?.start_time_hours?.length > 0 && editShift?.start_time_minutes?.length > 0) {
            setEditShift({
                ...editShift,
                start_time_meridiems: e[0].value,
                start_time: `${editShift.start_time_hours}:${editShift.start_time_minutes} ${e[0].value}`
            });
        } else {
            setEditShift({
                ...editShift,
                start_time_meridiems: e[0]?.value,
                start_time: ""
            });
        }
    };

    const onChangeEditEndTimeHours = (e) => {
        if (e[0] && editShift?.end_time_minutes?.length > 0 && editShift?.end_time_meridiems?.length > 0) {
            setEditShift({
                ...editShift,
                end_time_hours: e[0].value,
                end_time: `${e[0].value}:${editShift.end_time_minutes} ${editShift.end_time_meridiems}`
            });
        } else {
            setEditShift({
                ...editShift,
                end_time_hours: e[0]?.value,
                end_time: ""
            });
        }
    };

    const onChangeEditEndTimeMinutes = (e) => {
        if (e[0] && editShift?.end_time_hours?.length > 0 && editShift?.end_time_meridiems?.length > 0) {
            setEditShift({
                ...editShift,
                end_time_minutes: e[0].value,
                end_time: `${editShift.end_time_hours}:${e[0].value} ${editShift.end_time_meridiems}`
            });
        } else {
            setEditShift({
                ...editShift,
                end_time_minutes: e[0]?.value,
                end_time: ""
            });
        }
    };

    const onChangeEditEndTimeMeridiems = (e) => {
        if (e[0] && editShift?.end_time_hours?.length > 0 && editShift?.end_time_minutes?.length > 0) {
            setEditShift({
                ...editShift,
                end_time_meridiems: e[0].value,
                end_time: `${editShift.end_time_hours}:${editShift.end_time_minutes} ${e[0].value}`
            });
        } else {
            setEditShift({
                ...editShift,
                end_time_meridiems: e[0]?.value,
                end_time: ""
            });
        }
    };



  
    const tConvert = (time) => {
  // Match HH:MM(:SS)? in 24h format
  const match = time.toString().match(/^([01]\d|2[0-3]):([0-5]\d)(?::[0-5]\d)?$/);
  if (!match) return time; // return original if invalid

  let [_, hh, mm] = match;
  hh = parseInt(hh, 10);

  const meridiem = hh >= 12 ? 'PM' : 'AM';
  hh = hh % 12 || 12; // convert 0 -> 12

  // return clean 12-hour format with space before AM/PM
  return `${hh.toString().padStart(2, '0')}:${mm} ${meridiem}`;
};


    const convertTime12to24 = (time12h) => {

  if (!time12h) return null;

          if (/^\d{2}:\d{2}(:\d{2})?$/.test(time12h)) return time12h;

        var hours = Number(time12h.match(/^(\d+)/)[1]);
        var minutes = Number(time12h.match(/:(\d+)/)[1]);
        var AMPM = time12h.match(/\s(.*)$/)[1];
        if (AMPM == "PM" && hours < 12) hours = hours + 12;
        if (AMPM == "AM" && hours == 12) hours = hours - 12;
        var sHours = hours.toString();
        var sMinutes = minutes.toString();
        if (hours < 10) sHours = "0" + sHours;
        if (minutes < 10) sMinutes = "0" + sMinutes;
        return sHours + ":" + sMinutes;

    }
    function isNumber(n) {
        return !isNaN(parseFloat(n)) && !isNaN(n - 0)
    }

    function getLocalTimeHHMM() {
        const now = new Date();
        return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    }

    const startShift = async () => {

        let errors = {};
        let is_error = false;
        let s_time = null;
        let e_time = null;

        let regex = new RegExp(/((1[0-2]|0?[1-9]):([0-5][0-9]) ?([AaPp][Mm]))/);
        if (!addShift?.start_time || !addShift?.end_time || !regex.test(addShift?.start_time) || !regex.test(addShift?.end_time)) {
            errors["time"] = "Please enter valid start and end time. "
            is_error = true;
        }
        else {
            s_time = convertTime12to24(addShift?.start_time);
            e_time = convertTime12to24(addShift?.end_time);

        }

        if (!addShift?.hourly_rate || !isNumber(addShift?.hourly_rate)) {
            errors["hourly_rate"] = "Please enter valid hourly rate."
            is_error = true;

        }
        if (!addShift?.contract) {
            errors["contract"] = "Please enter valid hourly rate."
            is_error = true;
        }

        if (!addShift?.day0 && !addShift?.day1 && !addShift?.day2 && !addShift?.day3 && !addShift?.day4 && !addShift?.day5 && !addShift?.day6) {
            errors["days"] = "Please select one or more addShift days."
            is_error = true;

        }

        if (errors && is_error) {
            setErrors(errors);
            return false;
        }

        console.log(errors);




        axios.post(process.env.REACT_APP_API_URL + "/start-shift", {
            hourly_rate: addShift?.hourly_rate,
            overtime: addShift?.overtime,
            contract: addShift?.contract.value,
            start_time: s_time,
            end_time: e_time,
            day0: addShift?.day0,
            day1: addShift?.day1,
            day2: addShift?.day2,
            day3: addShift?.day3,
            day4: addShift?.day4,
            day5: addShift?.day5,
            day6: addShift?.day6,
            start_date: formatDate(new Date()),
            user_time: getLocalTimeHHMM(),
        }, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {

                    Swal.fire({ icon: "success", title: "Shift started.", text: "Your shift has been started successfully." });
                    getShift();
                    setAddShiftDetailModalOpen(false);

                    const interval = setInterval(() => {
                        //  getShiftEveryMinute();
                        getShift();
                    }, 5000); // 60,000 ms = 1 minute

                    return () => clearInterval(interval);


                }
                else {
                    Swal.fire({ icon: "error", title: "Error", text: "Shift cannot be started, please try later" });
                }
                setIsBtn(false)

            })
            .catch(function (error) {
                setIsBtn(false)
                if (error.status == 403) navigate("/login");
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });




    }


    const removeShift = async () => {


        axios.post(process.env.REACT_APP_API_URL + "/remove-shift", {}, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {

                    Swal.fire({ icon: "success", title: "The shift is cancelled.", text: "Your shift has been cancelled successfully." });
                    getShift();

                }
                else {
                    Swal.fire({ icon: "error", title: "Error", text: "Shift cannot be removed, please try later" });
                }
                setIsBtn(false)

            })
            .catch(function (error) {
                setIsBtn(false)
                if (error.status == 403) navigate("/login");
                else

                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });




    }


    const pauseShift = async () => {


        axios.post(process.env.REACT_APP_API_URL + "/pause-shift", {
             user_date: formatDate(new Date()), 
             user_time: getLocalTimeHHMM(),
             }, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {

                    Swal.fire({ icon: "success", title: "Shift Paused", text: "Your shift has been paused successfully" });
                    getShift();

                }
                else {
                    Swal.fire({ icon: "error", title: "Error", text: "Shift cannot be paused, please try later" });
                }
                setIsBtn(false)

            })
            .catch(function (error) {
                setIsBtn(false)
                if (error.status == 403) navigate("/login");
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });




    }


    const resumeShift = async () => {


        axios.post(process.env.REACT_APP_API_URL + "/resume-shift", 
            {
             user_date: formatDate(new Date()), 
             user_time: getLocalTimeHHMM(),
             }
            , {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                if (response?.data?.status) {

                    Swal.fire({ icon: "success", title: "Shift Resumed", text: "Your shift has been resumed successfully" });
                    getShift();

                }
                else {
                    Swal.fire({ icon: "error", title: "Error", text: "Shift cannot be resumed, please try later" });
                }
                setIsBtn(false)

            })
            .catch(function (error) {
                setIsBtn(false)
                if (error.status == 403) navigate("/login");
                else
                    Swal.fire({ icon: "error", title: "Error", text: error.message });

            });




    }

    const openEditModal = () => {
        if (!shift) return;

        const [startHour, startMinute] = shift.start_time?.split(":") || ["", ""];
        const [endHour, endMinute] = shift.end_time?.split(":") || ["", ""];

        const formatMeridiem = (hour) => (parseInt(hour, 10) >= 12 ? "PM" : "AM");
        const formatHour12 = (hour) => {
            const h = parseInt(hour, 10);
            return h % 12 === 0 ? "12" : (h % 12).toString().padStart(2, "0");
        };

        setEditShift({
            ...shift,
            edit_date: new Date().toISOString().split("T")[0], // default today
            contract: shift.contract ? { label: shift.contract.label || shift.contract, value: shift.contract.value || shift.contract } : null,
            start_time_hours: formatHour12(startHour),
            start_time_minutes: startMinute,
            start_time_meridiems: formatMeridiem(startHour),
            end_time_hours: formatHour12(endHour),
            end_time_minutes: endMinute,
            end_time_meridiems: formatMeridiem(endHour),
        });

        setEditShiftModalOpen(true);
    };

    const handleShiftUpdate = async () => {
        try {
            if (!editShift?.edit_date) {
                Swal.fire({ icon: "error", text: "Please select an effective date" });
                return;
            }


            const res = await axios.put(
                process.env.REACT_APP_API_URL + "/edit-shift",
                {
                    shift_id: shift?.shift_id,
                    user_id: shift?.user_id,
                    hourly_rate: editShift?.hourly_rate,
                    start_time: convertTime12to24(editShift?.start_time),
                    end_time: convertTime12to24(editShift?.end_time),
                    overtime: editShift?.overtime,
                    contract: editShift?.contract?.value || editShift?.contract,
                    day0: editShift?.day0 ? 1 : 0,
                    day1: editShift?.day1 ? 1 : 0,
                    day2: editShift?.day2 ? 1 : 0,
                    day3: editShift?.day3 ? 1 : 0,
                    day4: editShift?.day4 ? 1 : 0,
                    day5: editShift?.day5 ? 1 : 0,
                    day6: editShift?.day6 ? 1 : 0,
                    user_time: getLocalTimeHHMM(),
                    user_date: formatDate(new Date()),

                },
                {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                }
            );

            if (res?.data?.status) {

                if (res?.data?.today_passed) {
                    Swal.fire({ icon: "success", title: "Shift Updated", text: "Your shift has already begun; the changes will take effect starting from your next shift.", });
                } else {

                    Swal.fire({ icon: "success", title: "Shift Updated", text: "Shift was successfully updated.", });
                }
                    setEditShiftModalOpen(false);
                    getShift(); // refresh list
              

            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: res?.data?.message || "Unable to update shift",
                });
            }
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: err.message,
            });
        }
    };

    const saveOTHours = async () => {
    if (!otHours || isNaN(otHours) || otHours <= 0) {
        Swal.fire({ icon: "error", title: "Invalid Hours", text: "Please enter valid OT hours." });
        return;
    }

       const confirmResult = await Swal.fire({
        icon: "warning",
        title: "Confirm Overtime",
        text: `Are you sure you want to add ${otHours} OT hours for today's shift?`,
        showCancelButton: true,
        confirmButtonText: "Yes, add it",
        cancelButtonText: "Cancel",
    });

    if (!confirmResult.isConfirmed) return;


    try {
        const response = await axios.put(
            process.env.REACT_APP_API_URL + "/add-ot-hours",
            {
                user_date: formatDate(new Date()),
                user_time: getLocalTimeHHMM(),
                ot_hours: parseFloat(otHours),
            },
            {
                headers: { "Content-Type": "application/json" },
                withCredentials: true,
            }
        );

        if (response?.data?.status) {
            Swal.fire({ icon: "success", title: "OT Hours Added", text: "Overtime hours added successfully." });
            setAddOTModalOpen(false);
            setOtHours("");
            getShift();
        } else {
            Swal.fire({ icon: "error", title: "Error", text: response?.data?.message || "Failed to add OT hours." });
        }
    } catch (err) {
        Swal.fire({ icon: "error", title: "Error", text: err.message });
    }
};

    return (
        <>
            <div className="title-box">

                <div className="flex-equal justify-content-start " ></div>
                <h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white">Shift</h3>
                <div className="flex-equal justify-content-end" ></div>

            </div>
            {(shift && shift.paused == 0) ?
                <>
                    <div className="box justify-content-center" >

                        <div className="box-chart-lg" >

                            {totalEarning > 0 &&
                                <>
                                    <div className="chart" >
                                        <div className="donut-chart lg" >
                                            <PieChart
                                                lineWidth={14} paddingAngle={0} labelPosition={100} startAngle={270}
                                                labelStyle={{
                                                    "fontSize": "24px",
                                                    "fontFamily": "'Helvetica Neue LT Pro', sans-serif",
                                                    "fill": "#fff"
                                                }}
                                                data={[
                                                    { "title": "Completed", "value": completedEarning, "color": "#A1E312" },
                                                    { "title": "Total", "value": totalEarning, "color": "#3D3D3D" },
                                                ]}
                                            />


                                        </div>
                                        <div className="chart-center-label lg">
                                            <label className="fs-12 color-light chart-label">Daily Earnings </label>
                                            <label className="fs-26 color-white chart-amount">  ${todayEarning?.toFixed(2)}</label>
                                        </div>


                                    </div>

                                    <div className="statistics-days fd-column input-container">
                                        <div className="fd-row g-8">
                                            <label className={shift?.day0 ? "cursor-default day selected" : "cursor-default day"}  >S</label>
                                            <label className={shift?.day1 ? "cursor-default day selected" : "cursor-default day"}  >M</label>
                                            <label className={shift?.day2 ? "cursor-default day selected" : "cursor-default day"}  >T</label>
                                            <label className={shift?.day3 ? "cursor-default day selected" : "cursor-default day"}  >W</label>
                                            <label className={shift?.day4 ? "cursor-default day selected" : "cursor-default day"}  >T</label>
                                            <label className={shift?.day5 ? "cursor-default day selected" : "cursor-default day"} >F</label>
                                            <label className={shift?.day6 ? "cursor-default day selected" : "cursor-default day"} >S</label>
                                        </div>

                                    </div>


                                    <div className="statistics fd-row">
                                        <div className="fd-column g-16 align-items-center">
                                            <label className="fs-14 color-light chart-label" >Today</label>
                                            <label className="fs-26 color-white chart-label">  ${todayEarning?.toFixed(2)} </label>
                                        </div>
                                        <div className="fd-column g-16 align-items-center">
                                            <label className="fs-14 color-light chart-label" >This Week</label>
                                            <label className="fs-26 color-white chart-label">${thisWeekEarning?.toFixed(2)} </label>
                                        </div>
                                    </div>

                                </>
                            }
                        </div>


                    </div>
                    <div className="form-action">

                        <div className="action-bar ">

                            <div className="button-box">
                                <button className="btn btn-secondary" type="button" onClick={removeShift}>Cancel</button>

                                <button className="btn btn-primary me-2" type="button" onClick={openEditModal} disabled={!shift?.shift_id}  >Edit</button>
                                <button className="btn btn-primary me-2" type="button" onClick={() => setAddOTModalOpen(true)} >Add OT Hours</button>

                                <button className="btn btn-primary" onClick={pauseShift} disabled={isBtn}>{isBtn ? <Loading size={'20px'} /> : 'Pause'}</button>

                            </div>
                        </div>

                    </div>



                </>

                :
                <>
                    {shift && shift?.paused == 1 ?

                        <>
                            <div className="box justify-content-center" >

                                <div className="box-chart-lg" >
                                    {totalEarning > 0 &&
                                        <>
                                            <div className="chart" >
                                                <div className="donut-chart lg" >
                                                    <PieChart
                                                        lineWidth={14} paddingAngle={0} labelPosition={100} startAngle={270}
                                                        labelStyle={{
                                                            "fontSize": "24px",
                                                            "fontFamily": "'Helvetica Neue LT Pro', sans-serif",
                                                            "fill": "#fff"
                                                        }}
                                                        data={[
                                                            { "title": "Completed", "value": completedEarning, "color": "#FCBF04" },
                                                            { "title": "Total", "value": totalEarning, "color": "#3D3D3D" },
                                                        ]}
                                                    />


                                                </div>
                                                <div className="chart-center-label lg">
                                                    <label className="fs-12 color-light chart-label">Daily Earnings </label>
                                                    <label className="fs-26 color-white chart-amount">${todayEarning}</label>
                                                </div>


                                            </div>

                                            <div className="statistics-days fd-column input-container">
                                                <div className="fd-row g-8">
                                                    <label className={shift?.day0 ? "cursor-default day selected" : "cursor-default day"}  >S</label>
                                                    <label className={shift?.day1 ? "cursor-default day selected" : "cursor-default day"}  >M</label>
                                                    <label className={shift?.day2 ? "cursor-default day selected" : "cursor-default day"}  >T</label>
                                                    <label className={shift?.day3 ? "cursor-default day selected" : "cursor-default day"}  >W</label>
                                                    <label className={shift?.day4 ? "cursor-default day selected" : "cursor-default day"}  >T</label>
                                                    <label className={shift?.day5 ? "cursor-default day selected" : "cursor-default day"} >F</label>
                                                    <label className={shift?.day6 ? "cursor-default day selected" : "cursor-default day"} >S</label>
                                                </div>

                                            </div>

                                            <div className="statistics fd-row">
                                                <div className="fd-column g-16 align-items-center">
                                                    <label className="fs-14 color-light chart-label" >Today</label>
                                                    <label className="fs-26 color-white chart-label">${todayEarning}</label>
                                                </div>
                                                <div className="fd-column g-16 align-items-center">
                                                    <label className="fs-14 color-light chart-label" >This Week</label>
                                                    <label className="fs-26 color-white chart-label">${thisWeekEarning}.<span className="color-light">00</span> </label>
                                                </div>
                                            </div>

                                        </>
                                    }
                                </div>


                            </div>

                            <div className="form-action">
                                <div className="action-bar">
                                    <div className="button-box">

                                        {/* 🟡 New Edit Button */}
                                                                                <button className="btn btn-secondary me-2" type="button" onClick={removeShift}   >Cancel</button>

                                        <button className="btn btn-primary me-2" type="button" onClick={openEditModal} disabled={!shift?.shift_id}  >Edit</button>
 <button className="btn btn-primary me-2" type="button" onClick={() => setAddOTModalOpen(true)} >Add OT Hours</button>

                                        {/* Existing Cancel + Resume Buttons */}
                                        <button className="btn btn-success" onClick={resumeShift} disabled={isBtn}   >{isBtn ? <Loading size={'20px'} /> : 'Resume'}</button>

                                    </div>
                                </div>
                            </div>


                        </>

                        :
                        <div className="box" >

                            <div className="form-content p-32" >


                                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M48 24.0001C48 37.2549 37.2548 48.0001 24 48.0001C10.7452 48.0001 0 37.2549 0 24.0001C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24.0001ZM6 24.0001C6 33.9412 14.0589 42.0001 24 42.0001C33.9411 42.0001 42 33.9412 42 24.0001C42 14.0589 33.9411 6.00001 24 6.00001C14.0589 6.00001 6 14.0589 6 24.0001Z" fill="#3D3D3D" />
                                    <path d="M24 3.00001C24 1.34315 25.3484 -0.0193513 26.9924 0.187203C32.001 0.816523 36.7122 3.01434 40.4291 6.50477C44.1461 9.9952 46.6353 14.5591 47.5779 19.5184C47.8873 21.1461 46.6121 22.5774 44.9586 22.6815C43.305 22.7855 41.905 21.5186 41.5281 19.9052C40.7256 16.4703 38.9252 13.3233 36.3218 10.8786C33.7185 8.43384 30.4647 6.83459 26.9862 6.24939C25.3523 5.97451 24 4.65687 24 3.00001Z" fill="#A1E312" />
                                </svg>
                                <h3 className="color-white fs-36 text-center">Track Your Earnings</h3>

                                <label type="text" className="d-flex color-light fs-14 text-center" >
                                    Enter your shift details to see what you’re earning in real time, from hourly pay to overtime.
                                </label>


                                <button type="button" onClick={AddShiftDetails} className="btn btn-primary p-12" disabled={isBtn}>
                                    {isBtn ? <Loading size={'20px'} /> : ' Add Shift Details'}

                                </button>

                            </div>


                        </div>

                    }
                </>
            }


            <Modal
                isOpen={addShiftDetailModalOpen}
                onRequestClose={() => { setAddShiftDetailModalOpen(false) }}
                contentLabel="Add Shift Details"
                className="modal"
                overlayClassName="overlay"
            >
                <div className="modal-title" >

                    <div className="flex-equal justify-content-start " ></div>
                    <h3 className="flex-equal justify-content-center fs-18 fs-helvetica  color-white">Add Shift Details</h3>
                    <div className="flex-equal justify-content-end" >
                        <div className="icon" onClick={() => setAddShiftDetailModalOpen(false)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M8.0312 7L10.8154 9.78423L9.78423 10.8154L7 8.0312L4.21577 10.8154L3.18457 9.78423L5.9688 7L3.18457 4.21577L4.21577 3.18457L7 5.9688L9.78424 3.18457L10.8154 4.21577L8.0312 7Z" fill="white" />
                            </svg>
                        </div>

                    </div>

                </div>
                <div className="modal-body min-height max-height-550" >
                    <div className="box modal "  >
                        <div className="fd-row g-8 ">
                            <div className="input-container" >
                                <label >Hourly Rate</label>
                                <input autoComplete="off" type="text" id="hourly_rate" name="hourly_rate" value={addShift?.hourly_rate}
                                    onChange={(e) => setAddShift({ ...addShift, hourly_rate: e.target.value })}
                                />
                                {errors && errors["hourly_rate"] &&
                                    <div className="error">{errors["hourly_rate"]}</div>
                                }
                            </div>
                            <div className="input-container" >
                                <label >Overtime</label>
                                <input autoComplete="off" type="text" id="overtime" name="overtime" value={addShift?.overtime}
                                    onChange={(e) => setAddShift({ ...addShift, overtime: e.target.value })}
                                />

                            </div>

                        </div>
                        <div className="fd-row g-8 ">
                            <div className="fd-column input-container" >
                                <label >Contract</label>

                                <Select
                                    className="react-select" classNamePrefix="react-select"
                                    id="contract" name="contract"
                                    options={options_weeks}
                                    value={addShift?.contract}
                                    onChange={(e) => setAddShift({ ...addShift, contract: e })}
                                    noOptionsMessage={({ inputValue }) => !inputValue ? "Start Typing" : "No results found"}
                                />

                                {errors && errors["contract"] &&
                                    <div className="error">{errors["contract"]}</div>
                                }
                            </div>
                        </div>


                        <div className="card p-16 align-items-stretch color-white bg-grey">
                            {errors && errors["time"] &&
                                <div className="error">{errors["time"]}</div>
                            }

                            <div className="fd-row justify-content-space-between  align-items-center" >
                                <label className="fs-14" >Time Starts</label>
                                <label onClick={() => { setShiftStart(true); setShiftEnd(false); }} className={shiftStart ? "btn btn-secondary selected" : "btn btn-secondary"} >{addShift?.start_time ? tConvert(addShift?.start_time) : "__ : __"}</label>

                            </div>

                            {shiftStart &&
                                <div className="fd-row justify-content-center  align-items-center " >

                                    <div className="time-picker-grey fd-row justify-content-center  align-items-center " >

                                        <div className="fd-row" >
                                            <DSelect
                                                id="start_time_hours"
                                                options={options_hours}
                                                labelField="label"
                                                valueField="value"
                                                placeholder="__"
                                                className="form-control"
                                                dropdownHandle={false}
                                                color="#000000"
                                                onChange={onChangeStartTimeHours}
                                                values={addShift?.start_time_hours && [{ "label": addShift?.start_time_hours, "value": addShift?.start_time_hours }]}

                                            />
                                            <label className="time-picker-separator"> : </label>
                                            <DSelect
                                                id="start_time_minutes"
                                                options={options_minutes}
                                                labelField="label"
                                                valueField="value"
                                                placeholder="__"
                                                className="form-control"
                                                dropdownHandle={false}
                                                color="#000000"
                                                onChange={onChangeStartTimeMinutes}
                                                values={addShift?.start_time_minutes && [{ "label": addShift?.start_time_minutes, "value": addShift?.start_time_minutes }]}

                                            />

                                            <label className="time-picker-separator"> : </label>

                                            <DSelect
                                                options={options_meridiems}
                                                id="start_time_meridiems"
                                                labelField="label"
                                                valueField="value"
                                                placeholder="__"
                                                className="form-control"
                                                dropdownHandle={false}
                                                color="#000000"
                                                onChange={onChangeStartTimeMeridiems}
                                                values={addShift?.start_time_meridiems && [{ "label": addShift?.start_time_meridiems, "value": addShift?.start_time_meridiems }]}

                                            />


                                        </div>
                                    </div>
                                </div>
                            }

                            {shiftEnd &&
                                <div className="fd-row justify-content-center  align-items-center " >

                                    <div className="time-picker-grey fd-row justify-content-center  align-items-center " >

                                        <div className="fd-row" >
                                            <DSelect
                                                id="end_time_hours"
                                                options={options_hours}
                                                labelField="label"
                                                valueField="value"
                                                placeholder="__"
                                                className="form-control"
                                                dropdownHandle={false}
                                                color="#000000"
                                                onChange={onChangeEndTimeHours}
                                                values={addShift?.end_time_hours && [{ "label": addShift?.end_time_hours, "value": addShift?.end_time_hours }]}


                                            />
                                            <label className="time-picker-separator"> : </label>
                                            <DSelect
                                                id="end_time_minutes"
                                                options={options_minutes}
                                                labelField="label"
                                                valueField="value"
                                                placeholder="__"
                                                className="form-control"
                                                dropdownHandle={false}
                                                color="#000000"
                                                onChange={onChangeEndTimeMinutes}
                                                values={addShift?.end_time_minutes && [{ "label": addShift?.end_time_minutes, "value": addShift?.end_time_minutes }]}


                                            />

                                            <label className="time-picker-separator"> : </label>

                                            <DSelect
                                                id="end_time_meridiems"
                                                options={options_meridiems}
                                                labelField="label"
                                                valueField="value"
                                                placeholder="__"
                                                className="form-control"
                                                dropdownHandle={false}
                                                color="#000000"
                                                onChange={onChangeEndTimeMeridiems}
                                                values={addShift?.end_time_meridiems && [{ "label": addShift?.end_time_meridiems, "value": addShift?.end_time_meridiems }]}


                                            />


                                        </div>
                                    </div>
                                </div>
                            }


                            <div className="fd-row justify-content-space-between  align-items-center" >
                                <label className="fs-14" >Time Ends</label>
                                <label onClick={() => { setShiftStart(false); setShiftEnd(true); }} className={shiftEnd ? "btn btn-secondary selected" : "btn btn-secondary "} >{addShift?.end_time ? tConvert(addShift?.end_time) : "__ : __"}</label>

                            </div>
                        </div>


                        <div className="fd-row g-8 ">
                            <div className="fd-column input-container" >
                                <label >Shift Days</label>
                                <div className="fd-row g-8">
                                    <label className={addShift?.day0 ? "cursor-default day selected" : "cursor-default day"} onClick={() => setAddShift({ ...addShift, day0: !addShift?.day0 })} >S</label>
                                    <label className={addShift?.day1 ? "cursor-default day selected" : "cursor-default day"} onClick={() => setAddShift({ ...addShift, day1: !addShift?.day1 })}>M</label>
                                    <label className={addShift?.day2 ? "cursor-default day selected" : "cursor-default day"} onClick={() => setAddShift({ ...addShift, day2: !addShift?.day2 })}>T</label>
                                    <label className={addShift?.day3 ? "cursor-default day selected" : "cursor-default day"} onClick={() => setAddShift({ ...addShift, day3: !addShift?.day3 })}>W</label>
                                    <label className={addShift?.day4 ? "cursor-default day selected" : "cursor-default day"} onClick={() => setAddShift({ ...addShift, day4: !addShift?.day4 })}>T</label>
                                    <label className={addShift?.day5 ? "cursor-default day selected" : "cursor-default day"} onClick={() => setAddShift({ ...addShift, day5: !addShift?.day5 })}>F</label>
                                    <label className={addShift?.day6 ? "cursor-default day selected" : "cursor-default day"} onClick={() => setAddShift({ ...addShift, day6: !addShift?.day6 })}>S</label>
                                </div>
                                {errors && errors["days"] &&
                                    <div className="error">{errors["days"]}</div>
                                }

                            </div>
                        </div>

                    </div>

                </div>

                <div className="modal-footer  justify-content-space-between" >
                    <button className="btn btn-secondary" type="button" onClick={() => { setAddShiftDetailModalOpen(false) }}>Cancel</button>
                    <button className="btn btn-success" onClick={startShift} disabled={isBtn}>
                        {isBtn ? <Loading size={'20px'} /> : 'Start'}</button>

                </div>

            </Modal>


            <Modal
                isOpen={editShiftModalOpen}
                onRequestClose={() => setEditShiftModalOpen(false)}
                contentLabel="Update Shift Details"
                className="modal"
                overlayClassName="overlay"
            >
                <div className="modal-title">
                    <div className="flex-equal justify-content-start"></div>
                    <h3 className="flex-equal justify-content-center fs-18 fs-helvetica color-white">
                        Update Shift Details
                    </h3>
                    <div className="flex-equal justify-content-end">
                        <div className="icon" onClick={() => setEditShiftModalOpen(false)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M8.0312 7L10.8154 9.78423L9.78423 10.8154L7 8.0312L4.21577 10.8154L3.18457 9.78423L5.9688 7L3.18457 4.21577L4.21577 3.18457L7 5.9688L9.78424 3.18457L10.8154 4.21577L8.0312 7Z" fill="white" />
                            </svg>
                        </div>
                    </div>
                </div>

                <div className="modal-body min-height max-height-550">
                    <div className="box modal">
                        <div className="fd-row g-8">
                            <div className="input-container">
                                <label>Hourly Rate</label>
                                <input
                                    autoComplete="off"
                                    type="text"
                                    id="hourly_rate"
                                    name="hourly_rate"
                                    value={editShift?.hourly_rate || ""}
                                    onChange={(e) => setEditShift({ ...editShift, hourly_rate: e.target.value })}
                                />
                                {errors?.hourly_rate && <div className="error">{errors.hourly_rate}</div>}
                            </div>

                            <div className="input-container">
                                <label>Overtime</label>
                                <input
                                    autoComplete="off"
                                    type="text"
                                    id="overtime"
                                    name="overtime"
                                    value={editShift?.overtime || ""}
                                    onChange={(e) => setEditShift({ ...editShift, overtime: e.target.value })}
                                />
                            </div>
                        </div>

                     

                        <div className="card p-16 align-items-stretch color-white bg-grey">
                            {errors?.time && <div className="error">{errors.time}</div>}

                            {/* Start Time */}
                            <div className="fd-row justify-content-space-between align-items-center">
                                <label className="fs-14">Time Starts</label>
                                <label
                                    onClick={() => { setShiftStart(true); setShiftEnd(false); }}
                                    className={shiftStart ? "btn btn-secondary selected" : "btn btn-secondary"}
                                >
                                    {editShift?.start_time ? tConvert(editShift?.start_time) : "__ : __"}
                                </label>
                            </div>

                            {shiftStart && (
                                <div className="fd-row justify-content-center align-items-center">
                                    <div className="time-picker-grey fd-row justify-content-center align-items-center">
                                        <div className="fd-row">
                                            <DSelect
                                                id="start_time_hours"
                                                options={options_hours}
                                                labelField="label"
                                                valueField="value"
                                                placeholder="__"
                                                className="form-control"
                                                dropdownHandle={false}
                                                color="#000000"
                                                onChange={onChangeEditStartTimeHours} // ✅ call edit method
                                                values={editShift?.start_time_hours ? [{ label: editShift.start_time_hours, value: editShift.start_time_hours }] : []}
                                            />
                                            <label className="time-picker-separator"> : </label>
                                            <DSelect
                                                id="start_time_minutes"
                                                options={options_minutes}
                                                labelField="label"
                                                valueField="value"
                                                placeholder="__"
                                                className="form-control"
                                                dropdownHandle={false}
                                                color="#000000"
                                                onChange={onChangeEditStartTimeMinutes} // ✅ call edit method
                                                values={editShift?.start_time_minutes ? [{ label: editShift.start_time_minutes, value: editShift.start_time_minutes }] : []}
                                            />
                                            <label className="time-picker-separator"> </label>
                                            <DSelect
                                                id="start_time_meridiems"
                                                options={options_meridiems}
                                                labelField="label"
                                                valueField="value"
                                                placeholder="__"
                                                className="form-control"
                                                dropdownHandle={false}
                                                color="#000000"
                                                onChange={onChangeEditStartTimeMeridiems} // ✅ call edit method
                                                values={editShift?.start_time_meridiems ? [{ label: editShift.start_time_meridiems, value: editShift.start_time_meridiems }] : []}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}



                            {shiftEnd && (
                                <div className="fd-row justify-content-center align-items-center">
                                    <div className="time-picker-grey fd-row justify-content-center align-items-center">
                                        <div className="fd-row">
                                            <DSelect
                                                id="end_time_hours"
                                                options={options_hours}
                                                labelField="label"
                                                valueField="value"
                                                placeholder="__"
                                                className="form-control"
                                                dropdownHandle={false}
                                                color="#000000"
                                                onChange={onChangeEditEndTimeHours} // ✅ call edit method
                                                values={editShift?.end_time_hours ? [{ label: editShift.end_time_hours, value: editShift.end_time_hours }] : []}
                                            />
                                            <label className="time-picker-separator"> : </label>
                                            <DSelect
                                                id="end_time_minutes"
                                                options={options_minutes}
                                                labelField="label"
                                                valueField="value"
                                                placeholder="__"
                                                className="form-control"
                                                dropdownHandle={false}
                                                color="#000000"
                                                onChange={onChangeEditEndTimeMinutes} // ✅ call edit method
                                                values={editShift?.end_time_minutes ? [{ label: editShift.end_time_minutes, value: editShift.end_time_minutes }] : []}
                                            />
                                            <label className="time-picker-separator"> </label>
                                            <DSelect
                                                id="end_time_meridiems"
                                                options={options_meridiems}
                                                labelField="label"
                                                valueField="value"
                                                placeholder="__"
                                                className="form-control"
                                                dropdownHandle={false}
                                                color="#000000"
                                                onChange={onChangeEditEndTimeMeridiems} // ✅ call edit method
                                                values={editShift?.end_time_meridiems ? [{ label: editShift.end_time_meridiems, value: editShift.end_time_meridiems }] : []}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* End Time */}
                            <div className="fd-row justify-content-space-between align-items-center mt-16">
                                <label className="fs-14">Time Ends</label>
                                <label
                                    onClick={() => { setShiftStart(false); setShiftEnd(true); }}
                                    className={shiftEnd ? "btn btn-secondary selected" : "btn btn-secondary"}
                                >
                                    {editShift?.end_time ? tConvert(editShift?.end_time) : "__ : __"}

                                </label>
                            </div>

                            {/* Shift Days */}
                            <div className="fd-row g-8 mt-16">
                                <div className="fd-column input-container">
                                    <label>Shift Days</label>
                                    <div className="fd-row g-8">
                                        {["day0", "day1", "day2", "day3", "day4", "day5", "day6"].map((d, i) => (
                                            <label
                                                key={d}
                                                className={editShift?.[d] ? "cursor-default day selected" : "cursor-default day"}
                                                onClick={() => setEditShift({ ...editShift, [d]: !editShift?.[d] })}
                                            >
                                                {["S", "M", "T", "W", "T", "F", "S"][i]}
                                            </label>
                                        ))}
                                    </div>
                                    {errors?.days && <div className="error">{errors.days}</div>}
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

                <div className="modal-footer justify-content-space-between">
                    <button className="btn btn-secondary" onClick={() => setEditShiftModalOpen(false)}>Cancel</button>
                    <button className="btn btn-success" onClick={handleShiftUpdate} disabled={isBtn}>
                        {isBtn ? <Loading size={'20px'} /> : 'Update'}
                    </button>
                </div>
            </Modal>


<Modal
    isOpen={addOTModalOpen}
    onRequestClose={() => setAddOTModalOpen(false)}
    contentLabel="Add OT Hours"
    className="modal"
    overlayClassName="overlay"
>
    {/* Modal Header */}
    <div className="modal-title">
        <div className="flex-equal justify-content-start"></div>
        <h3 className="flex-equal justify-content-center fs-18 fs-helvetica color-white">
            Add OT Hours
        </h3>
        <div className="flex-equal justify-content-end">
            <div className="icon" onClick={() => setAddOTModalOpen(false)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path
                        d="M8.0312 7L10.8154 9.78423L9.78423 10.8154L7 8.0312L4.21577 10.8154L3.18457 9.78423L5.9688 7L3.18457 4.21577L4.21577 3.18457L7 5.9688L9.78424 3.18457L10.8154 4.21577L8.0312 7Z"
                        fill="white"
                    />
                </svg>
            </div>
        </div>
    </div>

    {/* Modal Body */}
    <div className="modal-body min-height max-height-250">
        <div className="box modal">
            <div className="fd-row g-8">
                <div className="input-container" style={{ width: "100%" }}>
                    <label>Overtime Hours</label>
                    <input
                         autoComplete="off"
                        type="number"
                        id="ot_hours"
                        name="ot_hours"
                        min="0"
                        step="0.5"
                        placeholder="Enter OT hours (e.g., 2.5)"
                        value={otHours}
                        onChange={(e) => setOtHours(e.target.value)}
                    />
                </div>
            </div>
        </div>
    </div>

    {/* Modal Footer */}
    <div className="modal-footer justify-content-space-between">
        <button className="btn btn-secondary" onClick={() => setAddOTModalOpen(false)}>
            Cancel
        </button>
        <button className="btn btn-success" onClick={saveOTHours}>
            Save
        </button>
    </div>
</Modal>


        </>


    );
};

export default ShiftNew;